export default function(callback) {
  return (event, ...rest) => {
    event.stopPropagation();
    callback(event, ...rest);
  };
}
